<template>
	<div v-if="song" style="padding: 100px 0">
		<!-- Audio controls -->
		<audio
			controls
			style="width: 95%; margin: 20px 2.5%; position: fixed; top: 40px; left: 0; z-index: 10"
			ref="audio"
		>
			<source :src="song.song_uri" type="audio/mpeg" />
			Your browser does not support the audio tag.
		</audio>

		<div
			style="position: fixed; top: 140px; left: 40px;z-index: 10; display: flex; flex-direction: column; align-items: center"
		>
			<div>
				<label style="font-size: 20px"> index: </label>
				<input
					style="font-size: 20px; text-align: center;  border: 0; width: 42px; margin: 16px;margin-top: 20px"
					v-model="current_index"
				/>
			</div>
			<div>
				<label style="font-size: 20px; "> start_time: </label>
				<input
					style="font-size: 20px; text-align: center;  border: 0; width: 42px; margin: 0; margin-bottom: 20px"
					v-model="song.start_time"
				/>
			</div>
			<div>
				<v-icon
					name="arrow-up"
					scale="2"
					@click="current_index > 0 && current_index--"
					style="cursor: pointer; margin: 10px"
				/>
				<v-icon
					name="arrow-down"
					scale="2"
					@click="current_index++"
					style="cursor: pointer; margin: 10px"
				/>
			</div>
			<v-icon
				name="language"
				scale="4"
				@click="get_translation"
				style="cursor: pointer; margin: 10px"
			/>
			<v-icon
				name="stopwatch"
				scale="4"
				@click="get_time"
				style="cursor: pointer; margin: 10px"
			/>
		</div>

		<!-- Lyrics -->
		<div>
			<h1 style="margin: 0; text-decoration: underline">
				{{ song.title }}
			</h1>
			<h3 style="margin: 0">
				<em>{{ song.artist }}</em>
			</h3>
			<h3 style="margin-top: 0" v-if="isResources">({{ song.id }})</h3>
			<div v-if="isResources">
				<div
					v-for="(line, index) in song.parsed_lines"
					:key="index"
					class="flex_center"
				>
					<div class="lyrics">
						<v-icon
							name="arrow-circle-down"
							scale="2"
							v-if="current_index === index"
						/>
						<div v-if="line.type !== 'blank'">
							<input
								v-model="line[song.lang]"
								style="width: 100%; font-size: 25px;"
								:placeholder="'[' + song.lang + '] lyrics'"
							/>
							<input
								v-model="line.fr"
								style="font-size: 16px"
								placeholder="paroles françaises"
							/>
						</div>
						<div v-else style="font-size: 24px">{{ line.text }}</div>

						<div v-if="line.time_end" style="font-size: 24px; color: green">
							{{ line.time_end }}
						</div>
					</div>
				</div>
			</div>
			<Missing v-else :song="song" :id="song.id" />
		</div>

		<!-- Footer -->
		<div class="footer" v-if="isResources">
			<button @click="() => add_line('INSTRU')">+ instru</button>
			<button @click="() => add_line('LYRICS')">+ line</button>
			<button @click="del_line">del</button>
			<button @click="save" style="background-color: green; color: white;">
				{{ isSaving ? "SAVING..." : "SAVE" }}
			</button>
		</div>
	</div>
</template>

<script>
import { song_col, translate } from "../../../firebase";
import { update_dictionary } from "./../helpers/dictionary.js";
import { break_by_word, clean } from "../helpers/lyrics.js";
import { add_nano_id } from "../helpers/general";
import Missing from "./Missing";

export default {
	components: {
		Missing,
	},
	data() {
		return {
			song: null,
			current_time: 0,
			current_index: 0,
			isSaving: false,
		};
	},
	computed: {
		song_id() {
			return this.$route.params.song_id;
		},
		isResources() {
			return this.song.parsed_lines && this.song.song_uri;
		},
	},
	watch: {
		song(song) {
			if (!song.nano_id) {
				add_nano_id(song.id);
			}
		},
	},
	created() {
		const { song_id } = this;
		song_col
			.doc(song_id)
			.get()
			.then((doc) => {
				const song = doc.data();
				this.song = song;
			});
	},
	mounted() {
		window.addEventListener("keypress", (e) => {
			if (e.code === "Equal") this.current_index++;
			if (e.code === "Minus") this.current_index--;
		});
	},
	methods: {
		get_time() {
			const current_time = this.$refs.audio.currentTime;
			this.song.parsed_lines[this.current_index].time_end = current_time;
			this.current_time = current_time;
			this.current_index++;
			if (this.current_index >= this.song.parsed_lines.length) this.save();
		},
		add_line(type) {
			let item;
			if (type === "INSTRU")
				item = { type: "blank", text: "*** music bit ***" };
			else if (type === "LYRICS") item = { fr: "", [this.song.lang]: "" };
			const is_last = this.current_index >= this.song.parsed_lines.length;

			if (is_last) {
				this.song.parsed_lines.push(item);
			} else {
				this.song.parsed_lines.splice(this.current_index, 0, item);
			}
		},
		del_line() {
			this.song.parsed_lines.splice(this.current_index, 1);
		},
		async save() {
			this.isSaving = true;
			let { song } = this;
			const { lang } = song;

			let parsed_lines = clean(song);
			parsed_lines = break_by_word(parsed_lines, lang);

			song.parsed_lines = parsed_lines;

			await Promise.all([
				update_dictionary(parsed_lines, lang),
				song_col.doc(this.song_id).set(song),
			]);
			this.isSaving = false;
		},
		async get_translation() {
			let { song, current_index: index } = this;
			const { lang } = song;
			if (!lang) return;
			const text = song.parsed_lines[index][lang];
			const lyricsTrans = (await translate({ text, to: "fr" })).data;
			song.parsed_lines[index].fr = lyricsTrans;
		},
	},
};
</script>

<style scoped>
.getLyricsClass {
	padding: 16px;
	background-color: red;
	color: white;
}
.downloadSongClass {
	padding: 16px;
	background-color: blue;
	color: white;
}
button {
	padding: 10px;
	cursor: pointer;
	font-size: 20px;
}
.flex_center {
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
}
.footer {
	position: fixed;
	bottom: 0;
	left: 0;
}
.footer button {
	flex: 1;
	width: 100%;
}
.lyrics {
	width: 100%;
	position: relative;
	margin: 25px;
}
.lyrics input {
	text-align: center;
	border: 0;
	width: stretch;
	margin: 10px;
}
</style>
